import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import  store from './common/store/index.js'
import VueI18n from 'vue-i18n';
import 'ant-design-vue/dist/antd.less'
// import 'bootstrap/dist/css/bootstrap.css'
import commonData from './mixins/commonData.js'

import  './assets/css/font.css'
import './assets/css/common.css'


import $ from 'jquery'
Vue.prototype.$ = $
// 富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

import zh from './common/locale/zh';
import en from './common/locale/en';
import zhHans from './common/locale/zh-Hans';
import JA from './common/locale/JA';
import KO from './common/locale/KO';
// google 登录


import headers from './components/headers.vue';
import footers from './components/footers.vue';



Vue.use(VueQuillEditor, /* { default global options } */)

Vue.mixin(commonData);
Vue.use(VueI18n);
Vue.use(Antd)

// 全局注册 headers 组件
Vue.component('headers', headers);
// 全局注册 footers 组件
Vue.component('footers', footers);
Vue.config.productionTip = false

import  router from './common/router/router';
import  * as http  from './common/request/request.js';
Vue.prototype.$http = http;
import {common} from './common/mixin/common.js';
Vue.mixin(common);


const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh-Hans', // 默认简体中文
  messages: {
    'zh-Hans': zhHans,
    'zh-Hant': zh,
    'en': en,
	'JA':JA,
	'KO':KO
  }
})

// this.$i18n.locale='en'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')